import React, { Component } from "react";
import { Card, CardHeader, CardBody, UncontrolledAlert } from "reactstrap";
import DataTable from "../../Shared/DataTable";
import { MdSearch } from "react-icons/md";

export class InstructorLibraryTable extends Component {
    render() {
        const columns = [
            {
                Header: "Name",
                accessor: "name",
                style: {
                    textAlign: "center",
                },
            },
            {
                Header: "Calories",
                id: "nutrients",
                accessor: "nutrients",
                style: {
                    textAlign: "center",
                },
                Cell: (row) => <span>{row.value.map((e) => (e.key === "calories" ? e.value : null))}</span>,
            },
        ];

        const { match, fetching, data, error, filterData, selectRow, pages, page, pageSize, deleteFoodItem, viewFoodsLibrary, setPageNumber, setPageSize, showModal } = this.props;

        // const actions = [
        //     {
        //         name: "view",
        //         btnText: "View",
        //         btnAction: viewFoodsLibrary,
        //         btnClass: "btn-success",
        //         btnIcon: MdSearch,
        //         hiddenParam: "hasPassed",
        //         tooltip: "View",
        //     },

        // ];

        return (
            <div>
                <Card className="pp4">
                    <CardHeader>Food items</CardHeader>

                    <CardBody>
                        {error && <UncontrolledAlert color="danger">{error.message}</UncontrolledAlert>}
                        <DataTable
                            columns={columns}
                            loading={fetching}
                            manual={true}
                            pages={pages}
                            page={page}
                            pageSize={pageSize}
                            urlParams={match}
                            data={data ? data.data : []}
                            count={data ? data.count : 0}
                            defaultPageSize={5}
                            deleteRow={deleteFoodItem}
                            selectRow={selectRow}
                            viewFoodsLibrary={viewFoodsLibrary}
                            filterData={filterData}
                            setPageNumber={setPageNumber}
                            setPageSize={setPageSize}
                            searchParam="searchKey"
                            //hideSearchParam={true}
                            searchPlaceholder="Search by name"
                            // actions={actions}
                            hideActions={true}
                        />
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default InstructorLibraryTable;
